// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../queries/useDataEngine';

export const DashboardService = {
  getAllSavedSearches: (params, loader = true) =>
    axios.get(BASE_URL + '/allsavedsearch', {
      params,
      loader,
    }),

  getAlertData: (params, loader = true) =>
    axios.get(BASE_URL + '/alert', {
      params,
      loader,
    }),

  getPipelineData: (params, loader = false) =>
    axios.get(BASE_URL + '/pipeline', {
      params,
      loader,
    }),

  getKibanDashboard: (params, loader = true) =>
    axios.get(BASE_URL + '/kibanadashboard', {
      params,
      loader,
    }),

  downloadConnectivityReport: (payload, loader = false) =>
    axios.post(BASE_URL + '/model-entity/report-architecture', payload, {
      loader,
      responseType: 'arraybuffer',
    }),
};
